import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
	GET_PUNCH_IN_CALL,
	GET_PUNCH_IN_DONE,
	GET_PUNCH_IN_FAIL,
	POST_PUNCH_IN_RECORD_CALL,
	POST_PUNCH_IN_RECORD_DONE,
	POST_PUNCH_IN_RECORD_FAIL,
	POST_PUNCH_IN_RECORD_QUEUE_CALL,
	POST_PUNCH_IN_RECORD_QUEUE_DONE,
	POST_PUNCH_IN_RECORD_QUEUE_FAIL,
	GET_DAY_SHIFTS_CALL,
	GET_DAY_SHIFTS_DONE,
	GET_DAY_SHIFTS_FAIL,
	GET_ALL_SHIFTS_CALL,
	GET_ALL_SHIFTS_DONE,
	GET_ALL_SHIFTS_FAIL,
	GET_SUITABLE_SHIFTS_CALL,
	GET_SUITABLE_SHIFTS_DONE,
	GET_SUITABLE_SHIFTS_FAIL,
	GET_SCHEDULE_SHIFTS_CALL,
	GET_SCHEDULE_SHIFTS_DONE,
	GET_SCHEDULE_SHIFTS_FAIL,
	GET_DAILY_SHIFTS_CALL,
	GET_DAILY_SHIFTS_DONE,
	GET_DAILY_SHIFTS_FAIL,
	GET_REST_PUNCH_RECORD_CALL,
	GET_REST_PUNCH_RECORD_DONE,
	GET_REST_PUNCH_RECORD_FAIL,
	CLEAR_REST_PUNCH_RECORD,
	POST_REST_PUNCH_RECORD_CALL,
	POST_REST_PUNCH_RECORD_DONE,
	POST_REST_PUNCH_RECORD_FAIL,
	DELETE_REST_PUNCH_RECORD_CALL,
	DELETE_REST_PUNCH_RECORD_DONE,
	DELETE_REST_PUNCH_RECORD_FAIL,
	GET_PUNCH_IN_RULE_CALL,
	GET_PUNCH_IN_RULE_DONE,
	GET_PUNCH_IN_RULE_FAIL,
	GET_PUNCH_IN_SHIFT_CALL,
	GET_PUNCH_IN_SHIFT_DONE,
	GET_PUNCH_IN_SHIFT_FAIL,
	GET_PUNCH_IN_SHIFTS_BY_RANGE_CALL,
	GET_PUNCH_IN_SHIFTS_BY_RANGE_DONE,
	GET_PUNCH_IN_SHIFTS_BY_RANGE_FAIL,
	SET_PUNCH_IN_STALE,
	PUSH_PUNCH_IN_RETRY_OUTCOME,
	CLEAR_PUNCH_IN_RETRY_OUTCOME,
	SET_ASYNC_PUNCH_ERROR_MODAL,
	CLEAR_ASYNC_PUNCH_ERROR_MODAL,
	SET_ASYNC_PUNCH_INTERACTION_LOCK,
	CLEAR_ASYNC_PUNCH_INTERACTION_LOCK,
	SET_MACHINE_PUNCH_ERROR,
} from '../types/punchIn';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialState = {
	punchIn: {},
	punchInSideEffect: defaultSideEffectState,
	postPunchInRecord: {},
	postPunchInRecordSideEffect: defaultSideEffectState,
	// 非同步 enqueue（202）的 request side-effect。isLoading 只涵蓋「送出到拿到 202」這段
	postPunchInRecordQueueSideEffect: defaultSideEffectState,
	// 非同步打卡失敗、在首頁要彈的 error modal；null 代表不顯示
	asyncPunchErrorModal: null,
	machinePunchError: null,
	// IDB write 尚未完成前的跨 route bridge；真正 record 可被 selector 讀到後即可清除。
	asyncPunchInteractionLock: null,
	dayShifts: {},
	dayShiftsSideEffect: defaultSideEffectState,
	allShifts: [],
	allShiftsSideEffect: defaultSideEffectState,
	// TC-17319 可選擇班別來源：適用班別 / 該日班表內班別（皆 IShiftInfo[]）
	suitableShifts: [],
	suitableShiftsSideEffect: defaultSideEffectState,
	scheduleShifts: [],
	scheduleShiftsSideEffect: defaultSideEffectState,
	// 該名使用者該日「排定」的班別（判斷當日有無排班，不受臨時加選打卡影響）
	dailyShifts: [],
	dailyShiftsSideEffect: defaultSideEffectState,
	getRestPunchRecord: [],
	getRestPunchRecordSideEffect: defaultSideEffectState,
	postRestPunchRecord: {},
	postRestPunchRecordSideEffect: defaultSideEffectState,
	deleteRestPunchRecordSideEffect: defaultSideEffectState,
	getPunchInRule: {},
	getPunchInRuleSideEffect: defaultSideEffectState,
	punchInShift: {},
	getPunchInShiftSideEffect: defaultSideEffectState,
	punchInShiftsByRange: {},
	getPunchInShiftsByRangeSideEffect: defaultSideEffectState,
	// 快取 fallback 時 true，fresh 回應時 false
	isPunchInStale: false,
	// 用 array 而非 single value：兩筆 retry 可能在 /hr 訂閱消化前先後完成，single value 會被覆蓋
	punchInRetryOutcomes: [],
};

export default handleActions({
	[GET_PUNCH_IN_CALL](state) {
		return update(state, {
			punchInSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PUNCH_IN_DONE](state, { payload: { res } }) {
		return update(state, {
			punchIn: { $set: res },
			punchInSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PUNCH_IN_FAIL](state, { payload }) {
		return update(state, {
			punchInSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[POST_PUNCH_IN_RECORD_CALL](state) {
		return update(state, {
			postPunchInRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[POST_PUNCH_IN_RECORD_DONE](state, { payload: { res } }) {
		return update(state, {
			postPunchInRecord: { $set: res },
			postPunchInRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[POST_PUNCH_IN_RECORD_FAIL](state, { payload }) {
		return update(state, {
			postPunchInRecordSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[POST_PUNCH_IN_RECORD_QUEUE_CALL](state) {
		return update(state, {
			postPunchInRecordQueueSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[POST_PUNCH_IN_RECORD_QUEUE_DONE](state) {
		return update(state, {
			postPunchInRecordQueueSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[POST_PUNCH_IN_RECORD_QUEUE_FAIL](state, { payload }) {
		return update(state, {
			postPunchInRecordQueueSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},

	[GET_DAY_SHIFTS_CALL](state) {
		return update(state, {
			dayShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_DAY_SHIFTS_DONE](state, { payload: { res } }) {
		return update(state, {
			dayShifts: { $set: res },
			dayShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_DAY_SHIFTS_FAIL](state, { payload }) {
		return update(state, {
			dayShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_ALL_SHIFTS_CALL](state) {
		return update(state, {
			allShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_ALL_SHIFTS_DONE](state, { payload: { res } }) {
		return update(state, {
			allShifts: { $set: res },
			allShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_ALL_SHIFTS_FAIL](state, { payload }) {
		return update(state, {
			allShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_SUITABLE_SHIFTS_CALL](state) {
		return update(state, {
			suitableShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_SUITABLE_SHIFTS_DONE](state, { payload: { res } }) {
		return update(state, {
			suitableShifts: { $set: res },
			suitableShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_SUITABLE_SHIFTS_FAIL](state, { payload }) {
		return update(state, {
			suitableShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_SCHEDULE_SHIFTS_CALL](state) {
		return update(state, {
			scheduleShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_SCHEDULE_SHIFTS_DONE](state, { payload: { res } }) {
		return update(state, {
			scheduleShifts: { $set: res },
			scheduleShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_SCHEDULE_SHIFTS_FAIL](state, { payload }) {
		return update(state, {
			scheduleShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_DAILY_SHIFTS_CALL](state) {
		return update(state, {
			dailyShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_DAILY_SHIFTS_DONE](state, { payload: { res } }) {
		return update(state, {
			dailyShifts: { $set: res },
			dailyShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_DAILY_SHIFTS_FAIL](state, { payload }) {
		return update(state, {
			dailyShiftsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_REST_PUNCH_RECORD_CALL](state) {
		return update(state, {
			getRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_REST_PUNCH_RECORD_DONE](state, { payload: { res } }) {
		return update(state, {
			getRestPunchRecord: { $set: res },
			getRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_REST_PUNCH_RECORD_FAIL](state, { payload }) {
		return update(state, {
			getRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	// 出勤紀錄詳情頁 unmount 清空（sideEffect 一起歸零，下次進頁 isLoading 才能正確驅動 loading 畫面）
	[CLEAR_REST_PUNCH_RECORD](state) {
		return update(state, {
			getRestPunchRecord: { $set: [] },
			getRestPunchRecordSideEffect: { $set: defaultSideEffectState },
		});
	},
	[POST_REST_PUNCH_RECORD_CALL](state) {
		return update(state, {
			postRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[POST_REST_PUNCH_RECORD_DONE](state, { payload: { res } }) {
		return update(state, {
			postRestPunchRecord: { $set: res },
			postRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[POST_REST_PUNCH_RECORD_FAIL](state, { payload }) {
		return update(state, {
			postRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[DELETE_REST_PUNCH_RECORD_CALL](state) {
		return update(state, {
			deleteRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[DELETE_REST_PUNCH_RECORD_DONE](state) {
		return update(state, {
			deleteRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[DELETE_REST_PUNCH_RECORD_FAIL](state, { payload }) {
		return update(state, {
			deleteRestPunchRecordSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},

	[GET_PUNCH_IN_RULE_CALL](state) {
		return update(state, {
			getPunchInRuleSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PUNCH_IN_RULE_DONE](state, { payload }) {
		return update(state, {
			punchInRule: { $set: payload },
			getPunchInRuleSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PUNCH_IN_RULE_FAIL](state, { payload }) {
		return update(state, {
			getPunchInRuleSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_PUNCH_IN_SHIFT_CALL](state) {
		return update(state, {
			getPunchInShiftSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PUNCH_IN_SHIFT_DONE](state, { payload }) {
		return update(state, {
			punchInShift: { $set: payload },
			getPunchInShiftSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PUNCH_IN_SHIFT_FAIL](state, { payload }) {
		return update(state, {
			getPunchInShiftSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_PUNCH_IN_SHIFTS_BY_RANGE_CALL](state) {
		return update(state, {
			getPunchInShiftsByRangeSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PUNCH_IN_SHIFTS_BY_RANGE_DONE](state, { payload }) {
		return update(state, {
			punchInShiftsByRange: { $set: payload },
			getPunchInShiftsByRangeSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PUNCH_IN_SHIFTS_BY_RANGE_FAIL](state, { payload }) {
		return update(state, {
			getPunchInShiftsByRangeSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},

	[SET_PUNCH_IN_STALE](state, { payload }) {
		return update(state, {
			isPunchInStale: { $set: !!payload },
		});
	},
	[SET_MACHINE_PUNCH_ERROR](state, { payload }) {
		return update(state, { machinePunchError: { $set: payload } });
	},

	[PUSH_PUNCH_IN_RETRY_OUTCOME](state, { payload }) {
		return update(state, {
			punchInRetryOutcomes: { $push: [payload] },
		});
	},

	[CLEAR_PUNCH_IN_RETRY_OUTCOME](state, { payload }) {
		return update(state, {
			punchInRetryOutcomes: { $apply: arr => arr.filter(item => item.id !== payload) },
		});
	},

	[SET_ASYNC_PUNCH_ERROR_MODAL](state, { payload }) {
		return update(state, {
			asyncPunchErrorModal: { $set: payload },
		});
	},
	[CLEAR_ASYNC_PUNCH_ERROR_MODAL](state, { payload }) {
		if (state.asyncPunchErrorModal?.id !== payload) return state;
		return update(state, {
			asyncPunchErrorModal: { $set: null },
		});
	},

	[SET_ASYNC_PUNCH_INTERACTION_LOCK](state, { payload }) {
		return update(state, {
			asyncPunchInteractionLock: { $set: payload },
		});
	},

	[CLEAR_ASYNC_PUNCH_INTERACTION_LOCK](state, { payload }) {
		if (payload && state.asyncPunchInteractionLock?.ownerId !== payload) return state;
		return update(state, {
			asyncPunchInteractionLock: { $set: null },
		});
	},
}, initialState);
